/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';
import Modal from 'components/molecules/Modal';
import { shortDateLabel } from 'domain/attend/shiftBoard/time';
import { boardStyles } from './styles';

export type UnconfirmDialogProps = {
  open: boolean;
  dateFrom: string;
  dateTo: string;
  onClose: () => void;
  onUnconfirm: () => void;
};

/**
 * ロック解除（A8 確定解除。通知はしない）
 *
 * 9/24 に「公開した日はロックし、公開ボタンがロック解除ボタンに変わる」形にした。
 */
const UnconfirmDialog: React.FC<UnconfirmDialogProps> = ({
  open, dateFrom, dateTo, onClose, onUnconfirm,
}) => (
  <Modal open={open} closeHandler={onClose} title="ロック解除" submitText="ロックを解除する" onSubmit={onUnconfirm} width="480px">
    <div css={boardStyles.modalBody}>
      <div>{`${shortDateLabel(dateFrom)} 〜 ${shortDateLabel(dateTo)} のロックを解除し、編集できるようにします。`}</div>
      <ul css={boardStyles.subText} style={{ paddingLeft: '18px', marginTop: '8px' }}>
        <li>解除しても、スタッフへの通知は送りません。</li>
        <li>直したあと「確定して公開」を押すと、翌朝の確定通知に変更内容（変更前 → 変更後）が載り、人件費も再計算されます。</li>
        <li>本部確定済みの日は解除できません。</li>
      </ul>
    </div>
  </Modal>
);

export default UnconfirmDialog;
